import React, { useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import SearchBox from '../components/SearchBox';
import SelectBox from '../components/SelectBox';
import Button from 'react-bootstrap/Button';
import {
  ColXsMdType,
  EmployeeInformationFilterType,
  LocationFilterType,
} from '../utils/Types';
import { DEFAULT_OPTION_LOCATION } from '../utils/Constant';
import { useAppSelector } from '../store/redux-hooks';
import { trackLocationSelector } from '../features/trackLocationSlice';
import LocationFilter from './LocationFilter';
import { employeeDataSelector } from '../features/employeeDataSlice';

interface IEmployeeInformationFilterProps {
  onApplyFilters: (filter: EmployeeInformationFilterType) => void;
}

const colSize: ColXsMdType = {
  xs: 6,
  md: 3,
};

const defaultFilter: EmployeeInformationFilterType = {
  employeeId: '',
  employeeName: '',
  mobileNumber: '',
  role: DEFAULT_OPTION_LOCATION,
  status: DEFAULT_OPTION_LOCATION,
  district: DEFAULT_OPTION_LOCATION,
  zone: DEFAULT_OPTION_LOCATION,
  state: DEFAULT_OPTION_LOCATION,
  city: DEFAULT_OPTION_LOCATION,
};
const EmployeeInformationFilter: React.FunctionComponent<
  IEmployeeInformationFilterProps
> = ({ onApplyFilters }) => {
  const [employeeInformationFilter, setEmployeeInformationFilter] =
    useState<EmployeeInformationFilterType>(defaultFilter);
  const roleOptionsRaw = useAppSelector(trackLocationSelector).roleOptions;
  const employeeStatusOption =
    useAppSelector(employeeDataSelector).employeeStatus;

  const roleOptions = roleOptionsRaw
    ? [DEFAULT_OPTION_LOCATION, ...roleOptionsRaw]
    : DEFAULT_OPTION_LOCATION;
  const onResetFilter = () => {
    setEmployeeInformationFilter(defaultFilter);
    onApplyFilters(defaultFilter);
  };
  return (
    <div className="border rounded ps-3 pt-2 pb-3 pe-3">
      <Row>
        <Col xs={6} md={3}>
          <SearchBox
            label="Search by Employee Id"
            placeHolder="Ex. 1001001"
            value={employeeInformationFilter.employeeId}
            onChange={(e: any) => {
              setEmployeeInformationFilter({
                ...employeeInformationFilter,
                employeeId: e.target.value,
              });
            }}
          />
        </Col>
        <Col xs={6} md={3}>
          <SearchBox
            label="Search by Employee Name"
            placeHolder="Ex. John Doe"
            value={employeeInformationFilter.employeeName}
            onChange={(e: any) => {
              setEmployeeInformationFilter({
                ...employeeInformationFilter,
                employeeName: e.target.value,
              });
            }}
          />
        </Col>
        <Col xs={6} md={2}>
          <SearchBox
            label="Mobile Number"
            placeHolder="Ex. 9517538520"
            value={employeeInformationFilter.mobileNumber}
            onChange={(e: any) => {
              const numberRegex = /^\d*$/;
              if (
                e.target.value.length <= 10 &&
                numberRegex.test(e.target.value)
              ) {
                setEmployeeInformationFilter({
                  ...employeeInformationFilter,
                  mobileNumber: e.target.value,
                });
              }
            }}
          />
        </Col>

        <Col xs={6} md={2}>
          <SelectBox
            label="Search by Role"
            options={roleOptions}
            className="css-select-bg"
            value={employeeInformationFilter.role}
            onChange={(event: any) => {
              setEmployeeInformationFilter({
                ...employeeInformationFilter,
                role: event,
              });
            }}
            showClear={false}
          />
        </Col>
        <Col xs={6} md={2}>
          <SelectBox
            label="Status"
            options={[DEFAULT_OPTION_LOCATION, ...employeeStatusOption]}
            className="css-select-bg"
            value={employeeInformationFilter.status}
            onChange={(event: any) => {
              setEmployeeInformationFilter({
                ...employeeInformationFilter,
                status: event,
              });
            }}
            showClear={false}
          />
        </Col>
      </Row>

      <LocationFilter
        filterData={{
          zone: employeeInformationFilter.zone,
          state: employeeInformationFilter.state,
          district: employeeInformationFilter.district,
          city: employeeInformationFilter.city,
        }}
        setLocationFilter={(filter: LocationFilterType) => {
          setEmployeeInformationFilter({
            ...employeeInformationFilter,
            zone: filter.zone,
            state: filter.state,
            city: filter.city,
            district: filter.district,
          });
        }}
        size={{
          zone: colSize,
          state: colSize,
          district: colSize,
          city: colSize,
        }}
      />

      <div className="d-flex justify-content-left mt-2">
        <Button
          variant="primary"
          className="cl-btn-primary"
          onClick={() => {
            onApplyFilters(employeeInformationFilter);
          }}
        >
          Submit
        </Button>
        <Button
          variant="outline-primary"
          className="mx-2 cl-btn-outline-primary"
          onClick={() => {
            onResetFilter();
          }}
        >
          Reset
        </Button>
      </div>
    </div>
  );
};

export default EmployeeInformationFilter;
